<template>
    <div class="Settings__page" :key="title">
        <Overlay />
        <v-row class="Settings__page__title" justify="center">
            <v-col cols="12" md="11">
                <h1>{{title}}</h1>
            </v-col>
        </v-row>
        <v-row class="Settings__page__forms" justify="center">
            <v-col cols="12" md="11">
                <slot name="settingsForms"></slot>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import Overlay from '@/components/Overlay';
export default {
    components: { Overlay },
    props: {
        title: {
            type: String,
            required: true,
        }
    },
};
</script>
<style lang="scss">
.Settings__page {
    flex: 0 0 100%;
    width: 100%;
    padding: 12px 30px 24px 24px;

    h2 {
        font-size: 1.25rem !important;
        font-weight: bold !important;
        margin-bottom: 12px !important;
    }
}
</style>
